import { render } from "./SiteAssets.vue?vue&type=template&id=3a6c8856&scoped=true"
import script from "./SiteAssets.vue?vue&type=script&lang=js"
export * from "./SiteAssets.vue?vue&type=script&lang=js"

import "./SiteAssets.vue?vue&type=style&index=0&id=3a6c8856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6c8856"]])

export default __exports__